import { ref, computed, Ref } from '@vue/composition-api';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import store from '@/renderer/store/index';
import Crumbs from '../scripts/Crumbs';
interface RootDir {
  name: '';
  type: 'all';
  path: [];
  authorityList: SMH.AuthorityList;
}
type FileItemData = SMH.SpaceFileItemData | RootDir;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (spaceId: Ref<SpaceId>, spaceOrgId: Ref<number>, importFlag?: boolean) => {
  // 需滚动查询时传marker与limit
  const pageParams = {
    nextMarker: 0,
    limit: 100, // 目前单页最大数
  };

  const currentSubDirList: Ref<FileItemData[]> = ref([]);
  const currentGroupList: Ref<SMH.ColleborationSpaceInfoData[]> = ref([]);
  const isLoading = ref(false);
  const isGroupLoading = ref(false);
  const isDirMoreLoading = ref(false);
  const dirHasMore = ref(false);
  const dirCrumbs = new Crumbs<FileItemData>('name');
  const dirPath = computed(() => dirCrumbs.value.map(dir => dir.name));
  const dirPathString = computed(() => dirPath.value.filter(s => s).join('/'));
  const methods = {
    async pullDirList(onlyDir?: boolean, loadmore = false) {
      if (!store.getters.hasPersonalSpace && !spaceId.value) return;
      const params = {
        limit: pageParams.limit,
        dirPath: dirPathString.value,
        orderBy: 'modificationTime',
        orderByType: 'desc',
        spaceId: spaceId.value,
        spaceOrgId: spaceOrgId.value,
        shareToken: '',
        ...(onlyDir && {
          filter: 'onlyDir',
        }),
        // 当加载更多时传nextMark标识，初始不传mark字段，否则不会按时间降序排列
        ...(loadmore && {
          marker: pageParams.nextMarker,
        }),
      };
      try {
        // 加载更多时此处不用loading
        if (!loadmore) {
          isLoading.value = true;
        } else {
          isDirMoreLoading.value = true;
        }
        const { data } = await smh.commonAPI.listDirectory(params);
        pageParams.nextMarker = data?.nextMarker || 0;
        dirHasMore.value = !!pageParams.nextMarker;
        const { authorityList, contents } = data;
        if (loadmore) {
          currentSubDirList.value.push(...contents);
        } else {
          currentSubDirList.value = contents;
        }
        // currentSubDirList.value = importFlag ? contents : contents.filter(item => item.type === 'dir'); // 协作群组导入显示文件，报存网盘不显示
        if (!dirCrumbs.value.length) {
          dirCrumbs.push({
            name: '',
            type: 'all',
            path: [],
            authorityList,
          });
        }
        isLoading.value = false;
        isDirMoreLoading.value = false;
      } catch (e) {
        isLoading.value = false;
        isDirMoreLoading.value = false;
        tips.error(e as MsgError);
      }
    },
    // 查询群组列表
    async pullGroupList(isPullGroup = false) {
      if (!isPullGroup) return;
      try {
        isGroupLoading.value = true;
        /** TODO: 目前查询协作空间群组的接口不支持查看更多式查询 */
        const { data } = await smh.userAPI.listCollaborationSpaces({
          page: 1,
          pageSize: 1000,
          withFileCount: 1,
          withDirectory: 1,
        });
        isGroupLoading.value = false;
        currentGroupList.value = data.contents;
      } catch (error) {
        isGroupLoading.value = false;
        tips.error(error as MsgError);
      }
    },
    onLoadMore(onlyDir?: boolean) {
      methods.pullDirList(onlyDir, true);
    },
  };
  return {
    dirHasMore,
    dirPath,
    dirPathString,
    currentGroupList,
    currentSubDirList,
    dirCrumbs,
    isLoading,
    isGroupLoading,
    isDirMoreLoading,
    pageParams,
    methods,
  };
};
